export function functionsForWordPress() {
/*
    let prettySocial = $(".prettySocial");

    if (prettySocial.length) {
        prettySocial.prettySocial();
    }*/


    let
        wpcf7Elm = document.querySelector(".wpcf7"),
        wpcf7Obj = $(".wpcf7"),
        validationClasses = function () {
            wpcf7Obj.find(".form-item").each(function () {
                $(this).removeClass("wpcf7-not-valid");
            });

            wpcf7Obj.find(".wpcf7-not-valid").each(function () {
                $(this).closest(".form-item").addClass("wpcf7-not-valid");
            });
        };

    if (wpcf7Elm) {
        wpcf7Elm.addEventListener("wpcf7mailsent", function () {
            validationClasses();
        }, false);

        wpcf7Elm.addEventListener("wpcf7invalid", function () {
            validationClasses();
        }, false);
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/functionsForWordPress.js